/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { CustomImage } from '@components/CustomImage/CustomImage';

const styles = StyleSheet.create({
  docUploadIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
});

export interface DocUploadIconProps {
  imageName: string;
  size: 'small' | 'xlarge';
  background?: 'light' | 'dark';
}

export const DocUploadIcon: React.FC<DocUploadIconProps> = ({ imageName, size }) => {
  return (
    <div className={css(styles.docUploadIcon)}>
      <CustomImage imageName={imageName} size={size} />
    </div>
  );
};
